import { render, staticRenderFns } from "./SchoolPeople.vue?vue&type=template&id=21c83dfe&"
import script from "./SchoolPeople.vue?vue&type=script&lang=js&"
export * from "./SchoolPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports